import(/* webpackMode: "eager" */ "/app/src/app/(secured)/[workspaceId]/layout.tsx");
